import React from "react";
import Paginator from "./paginator.jsx";
import moment from "moment";
import context from "../../lib/context.js";
import { browserHistory } from "react-router";
import { Breadcrumb } from "react-bootstrap";

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);


    }

    componentDidMount() {

    }

    render() {
        if (this.props.links.length == 0) {
            return <div></div>
        }

        var items = [];
        this.props.links.map(function(item, i) {
            items.push(<Breadcrumb.Item href={item.link} active={!item.active}>{item.name}</Breadcrumb.Item>)
        });

        return(
            <Breadcrumb className="ap-navigation">
                {items}
            </Breadcrumb>
        );
    }
}